import { Dispatch } from 'redux';
import _ from 'lodash';
import { ajax, arr2Tree } from 'utils';

export const LOAD_DETAIL = 'mpc/lsProjectDetail/load_detail';
export const LOAD_DETAIL_SUCCESS = 'mpc/lsProjectDetail/load_detail_success';
export const LOAD_DETAIL_FAILED = 'mpc/lsProjectDetail/load_detail_failed';
export const CLEAR_DETAIL = 'mpc/lsProjectDetail/clear_detail';
export const TOOGLE_DRAWER_SIDER_SHOW = 'mpc/lsProjectDetail/toggle_drawer_sider_modal';
export const LOAD_SIDER = 'mpc/lsProjectDetail/load_sider';
export const LOAD_SIDER_SUCCESS = 'mpc/lsProjectDetail/load_sider_success';
export const LOAD_SIDER_FAILED = 'mpc/lsProjectDetail/load_sider_failed';
export const CHANGE_SIDER_SELECTED_KEYS = 'mpc/lsProjectDetail/change_sider_selected_keys';
export const GET_JOURNALS_SUCCESS = 'mpc/lsProjectDetail/get_journals_success';
export const LOADING = 'mpc/lsProjectDetail/loading';
export const GET_ERROR = 'mpc/lsProjectDetail/get_error';

export interface LoadDetail {
  type: typeof LOAD_DETAIL;
  data: any;
}
export interface LoadDetailSuccuess {
  type: typeof LOAD_DETAIL_SUCCESS;
  data: any;
}
export interface LoadDetailFailed {
  type: typeof LOAD_DETAIL_FAILED;
  data: any;
}
export interface ClearDetail {
  type: typeof CLEAR_DETAIL;
}
export interface ToggleDrawerSiderShow {
  type: typeof TOOGLE_DRAWER_SIDER_SHOW;
  data: any;
}
export interface LoadSider {
  type: typeof LOAD_SIDER;
}
export interface LoadSiderSuccess {
  type: typeof LOAD_SIDER_SUCCESS;
  data: any;
}
export interface LoadSiderFailed {
  type: typeof LOAD_SIDER_FAILED;
  data: any;
}

export interface CommonInterfaces {
  type: typeof LOADING | typeof GET_ERROR | typeof GET_JOURNALS_SUCCESS;
  data: any;
  fromType?: string;
}

export type ProjectDetailActions =
  | LoadDetail
  | LoadDetailSuccuess
  | LoadDetailFailed
  | ClearDetail
  | ToggleDrawerSiderShow
  | LoadSider
  | LoadSiderSuccess
  | LoadSiderFailed
  | CommonInterfaces;

export function loadDetail(id: string | number, extra: any = {}, menuKey: string) {
  const { changedBySider = false } = extra;
  const isAdvance = menuKey === 'myAdvance' ? 'is_advance=true' : '';
  return (dispatch: Dispatch, getState: any) => {
    dispatch({ type: LOAD_DETAIL, data: { changedBySider } });
    ajax({
      url: `outsource/ls/projects/detail?id=${id}&${isAdvance}`,
      method: 'POST',
    }).then((res: any) => {
      const data = _.get(res, ['data'], {});
      // const detail = { ...data, has_sider: !isBlank(data.parent_id) };
      const detail = { ...data };
      dispatch({ type: LOAD_DETAIL_SUCCESS, data: { detail } });

      if (detail.has_sider) {
        // @ts-ignore
        dispatch(toggleDrawerSiderShow(true, { id: detail.id }));
      }
    }).catch((err: any) => {
      dispatch({ type: LOAD_DETAIL_FAILED });
    });
  };
}

export function clearDetail() {
  return (dispatch: Dispatch, getState: any) => {
    dispatch({ type: CLEAR_DETAIL });
  };
}
export function toggleDrawerSiderShow(showDrawerSider: boolean, extra: any = {}) {
  const { id } = extra;
  return (dispatch: Dispatch, getState: any) => {
    dispatch({ type: TOOGLE_DRAWER_SIDER_SHOW, data: { showDrawerSider } });
    const siderData = _.get(getState(), ['lsProjectDetail', 'siderData']);
    if (showDrawerSider && !siderData) {
      // @ts-ignore
      dispatch(loadSider(id));
    }
  };
}
export function loadSider(id: any) {
  return (dispatch: Dispatch, getState: any) => {
    dispatch({ type: LOAD_SIDER });
    ajax({
      url: `outsource/ls/projects/left_navs`,
      method: 'GET',
      body: { id },
    }).then((res: any) => {
      const resData = _.get(res, ['data'], {});
      const siderData = arr2Tree(resData);
      const data = { siderData, siderSelectedKeys: [`${id}`] };
      dispatch({ type: LOAD_SIDER_SUCCESS, data: { ...data } });
    }).catch((err: any) => {
      dispatch({ type: LOAD_SIDER_FAILED });
    });
  };
}

export function getJournals(body: any) {
  return {
    types: [LOADING, GET_JOURNALS_SUCCESS, GET_ERROR],
    promise: () =>
      ajax({
        url: 'outsource/ls/projects/journals',
        method: 'POST',
        body,
      }),
    fromType: 'journals',
  };
}
